<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
                            <router-link class="btn GeneralLeave-back btnBack" to="/modificaciones-datos-personales">
							    <font-awesome-icon icon="fa-solid fa-circle-chevron-left" /> Atrás
							</router-link>
                        </div>
						<div class="title">
							<h3>Modificaciones Datos Personales</h3>
						</div>
					</div>
                    <div class="itemList-header">
                        <!-- <h1>Ver {{ permiso }}</h1> -->
                        <h1>Ver</h1>
                    </div>
                    <div id="Detail" class="detail-Generalleave">
                        <div class="row">
                            <div class="col-md-6 col-sm-6 col-xs-6">
                                <label for="">Fecha Solicitud</label>
                                <p>{{formatDate(modificacion.fecha)}}</p>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-6">
                                <label for="">Tipo de Modificación</label>
                                <p>({{modificacion.tipoModificacion}}) {{descripcionTipoModificacion}}</p>
                            </div>
                        </div>
                        
                        <hr />
                        
                        <div class="row">
                            <div class="col-md-12 col-sm-12 col-xs-12">
                                <label for="">Observaciones</label>
                                <p>{{modificacion.observaciones}}</p>
                            </div>
                        </div>

                        <hr />

                        <div class="form-group">
                            <label for="">Adjunto/s</label>
                                <div v-if="modificacion.adjunto_1 && modificacion.adjunto_1!='null'" id="div_adjunto_1">
                                    <a href="javascript:void(0);" @click="descargarAdjunto(modificacion.adjunto_1)" title="haz click para descargar...">
                                        {{ modificacion.adjunto_1 }}
                                    </a>
                                </div>
                                <div v-if="modificacion.adjunto_2 && modificacion.adjunto_2!='null'" id="div_adjunto_2">
                                    <a href="javascript:void(0);" @click="descargarAdjunto(modificacion.adjunto_2)" title="haz click para descargar...">
                                        {{ modificacion.adjunto_2 }}
                                    </a>
                                </div>
                                <div v-if="modificacion.adjunto_3 && modificacion.adjunto_3!='null'" id="div_adjunto_3">
                                    <a href="javascript:void(0);" @click="descargarAdjunto(modificacion.adjunto_3)" title="haz click para descargar...">
                                        {{ modificacion.adjunto_3 }}
                                    </a>
                                </div>
                            <p></p>
                        </div>
                        
                        <hr />

                        <div class="row">
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <label for="">Estado</label>
                                <p>{{modificacion.estado}}</p>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <label for="">Tipo de permiso</label>
                                <p>Campo Modificación</p>
                            </div>
                        </div>
                        
                        <hr />
                        
                        <div class="form-group">
                            <!-- <label for="">Tramites: {{ permisosTramites }}</label> -->
                            <label for="">Tramites:</label>
                            <ul class="listaTramites" v-for="(modificacionTramite, index) in modificacionesTramites">
                                <li>
                                    <strong>
                                       <u>Tramite {{ modificacionesTramites.length - index }}</u>: {{ formatDate(modificacionTramite.fecha) }} / {{ modificacionTramite.estado }}
                                    </strong>
                                </li>
                                <div>
                                    <i>
                                        {{ modificacionTramite.observacionesRRHH }}
                                    </i>
                                </div>
                            </ul>
                        </div>
                    </div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import Encabezado from "@/components/Encabezado.vue";
    import Footer from "@/components/Footer.vue";

    export default {
        name: "DetalleModificacionDatosPersonales",
		components: {
            Encabezado,
            Footer,
        },
		data() { 
			return{}
		},
		mounted() {
			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
		},
		computed:{
            modificaciones: function(){
				let modificaciones = this.$store.state.perfil.modificaciones || [];
			
                return (Array.isArray(modificaciones))? modificaciones : [modificaciones];
			},
			modificacion: function(){
                let modificacion = null;

				if (this.modificaciones.length > 0){
                    modificacion = this.modificaciones.find(modificacion=>{
                        return modificacion.id == this.$route.params.id_modificacion;
                    });
				}

                return modificacion;
        
			},
            descripcionTipoModificacion: function(){
                let tipoModificacion = {};
                let tiposModificacion = this.$store.state.perfil.tiposModificacion || [];
                let id_tipoModificacion = this.modificacion.tipoModificacion;

                tiposModificacion = (Array.isArray(tiposModificacion))?tiposModificacion:[tiposModificacion];
                
                tipoModificacion = tiposModificacion.find(function(tipomodificacion){
                    return tipomodificacion.id == id_tipoModificacion;
                })

                return tipoModificacion.nombre;
            },
            modificacionesTramites: function(){
                const tramites = this.modificacion.tramites || [];
                
                return (Array.isArray(tramites))? tramites: [tramites];
            }            
		},
        methods:{
            formatDate: function (date) {
				return this.moment(date).format('DD/MM/YYYY');
			},
            descargarAdjunto: function(adjunto){
                // console.log(adjunto);
                this.$store.dispatch("descargarAdjunto", {
                    adjunto: adjunto,
                    categoria: 'modificaciones',
                    id: this.modificacion.id
                });
            }
        }
    };
</script>

<style>
    @import "../assets/styles/home.css";
</style>
